export default "__VITE_ASSET__BuLxDEv1__"